import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const store = new Vuex.Store({
  state: {
    token: null,
    profile_picture: null,
    email: null,
    fullname: null,
    list: null,
    retry: null,
  },
  actions: {},
  mutations: {
    token (state, payload) {
      state.token = payload
    },
    picture (state, payload) {
      state.profile_picture = payload
    },
    email (state, payload) {
      state.email = payload
    },
    name (state, payload) {
      state.fullname = payload
    },
    list (state, payload) {
      state.list = payload
    },
    retry(state, payload) {
      state.retry = payload
    },
  },
  getters: {
    token: state => state.token,
    picture: state => state.profile_picture,
    email: state => state.email,
    name: state => state.fullname,
    list: state => state.list,
    retry: state => state.retry,
  },
  plugins: [vuexLocal.plugin]
});
export default store
